/* global angular, moment */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('clientnotes', {
      restrict: 'E',
      bindings: {
        clientid: '<',
        mode: '@?'
      },
      template: `
       <vcarea model="vm.client.notes"
               parentsave="vm.childsave(key, value)"
               id="notes"
               options="vm.options">
       </vcarea>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Client', 'ClientHelper', 'Rlog', 'vertxEventBusService', '$window',
        function ($log, Client, ClientHelper, Rlog, vertxEventBusService, $window) {
          let vm = this;
          vm.childsave = childsave;
          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};


          vm.$onInit = function () {
            if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
              vm.kunde = 'Patient';
              vm.testkunde = 'Testpatient';
            }
            else {
              vm.mode = 'client';
              vm.kunde = 'Kunde';
              vm.testkunde = 'Testkunde';
            }

            if (angular.isDefined(vm.clientid)) {
              ClientHelper.find(vm.mode, vm.clientid).$then((client) => {
                vm.client = client;
              }, (error) => {
                vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
                Rlog.error('client', 'clienteditor', 'client.$find() failed', {id: vm.clientid});
              });
            }
          }; // $onInit()



          // vm.clientid might be late propagating, get client on first real change

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(vm.clientid)) {
                ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
                  vm.client = client;
                }, function (err) {
                  $log.error('client not found, id: ', vm.clientid);
                  Rlog.error('client', 'clientnotes', 'client not found', {_id: vm.clientid});
                });
              }
            }
          };

          function childsave(key, value) {
            if (vm.client[key] !== value) {
              vm.client[key] = value;
              if (vm.client.$hasPendingActions) {
                vm.client.$cancel();
              }
              savesave();
            }

          }

          function savesave() {
            // $log.debug('debug: savesave vm.client: ', vm.client.svdata);
            vm.client.$save().$then(function () {
            }, function () {
              $log.debug('debug/error: client save failed!');
              Rlog.error('client', 'clienteditor', 'client.$save() failed', {id: client._id});
            });
          }

          vertxEventBusService.on('patients.update', function (message) {
            $log.debug('debug: Patient update received: ', message);
            let messages = message.split(':');
            // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
              vm.client.$refresh().$then(function () {
                $log.debug('debug: clienteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              }, function (error) {
                $log.debug('debug: clienteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              });
            }
          });

          vertxEventBusService.on('clients.update', function (message) {
            $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
              vm.client.$refresh().$then(function () {
                $log.debug('debug: clienteditor refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              }, function (error) {
                $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              });
            }
          });

        }
      ] // controller
    }); // component

// klammerfriedhof
}());